// eslint-disable-next-line import/prefer-default-export
export class SubmenuScrollClass {
  #submenuSelector = "";

  #activeItemSelector = "";

  constructor(props) {
    this.#submenuSelector = props.submenuSelector;
    this.#activeItemSelector = props.activeItemSelector;
  }

  get #$activeItem() {
    return document.querySelector(this.#activeItemSelector);
  }

  get #$submenu() {
    return document.querySelector(this.#submenuSelector);
  }

  scrollToActive() {
    if (!this.#$activeItem || !this.#$submenu) return;

    // Center the active item in the submenu
    const scrollLeft =
      this.#$activeItem.offsetLeft -
      this.#$submenu.clientWidth / 2 +
      this.#$activeItem.clientWidth / 2;

    this.#$submenu.scrollTo({
      left: scrollLeft,
      behavior: "smooth"
    });
  }
}
